<template>
  <div>
    <div class="mt-2 mb-2">
      <p>Selecciona los colores que representen mejor la identidad de tu marca. Estos se aplicarán a insignias y botones
        , creando una experiencia de compra coherente y personalizada para tus clientes. Recomendamos utilizar colores
        que garanticen contraste y legibilidad.</p>
    </div>
    <div>
      <ul class="mb-1 pt-1 pl-1 d-flex justify-content-around">
        <li class="col-6 col-md-6 col-lg-3 mr-2">
          <span title="insignias">Selecciona un color para las <strong>insignias</strong>.</span>
          <color-picker id="badges_color" :color.sync="form.badges_color" class="mt-2"></color-picker>
        </li>
        <li class="col-6 col-md-6 col-lg-3">
          <span title="botones">Selecciona un color para los <strong>botones</strong>.</span>
          <color-picker id="buttons_color" :color.sync="form.buttons_color" class="mt-2"></color-picker>
        </li>
      </ul>
    </div>
    <div class="w-full d-flex justify-content-end mt-3 mb-4">
      <b-button variant="warning" :disabled="!canContinue" @click="continuar">Continuar</b-button>
    </div>
  </div>
</template>

<script>
import ColorPicker from '@/views/components/custom/color-picker/ColorPicker.vue'

export default {
  components: { ColorPicker },
  props: {
    canContinue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      color: '#000000',
      font: {},
      form: {},
      loadedConfig: null,
      defaultConfig: {
        badges_color: '#B0B0B0',
        buttons_color: '#B0B0B0'
      }
    }
  },
  watch: {
    form: {
      handler(val) {
        const personalizados = val.badges_color !== this.defaultConfig.badges_color &&
          val.buttons_color !== this.defaultConfig.buttons_color
        this.$emit('colors-customized', personalizados)
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.loadFormDefault()
    this.loadedConfig = { ...this.defaultConfig }
  },
  methods: {
    loadFormDefault() {
      this.form = { ...this.defaultConfig }
    },
    loadCustomConfig() {
      this.form = { ...this.form, ...this.loadedConfig }
    },
    saveColorsConfig() {
      const payload = {
        badges_color: this.form.badges_color,
        buttons_color: this.form.buttons_color
      }
      console.log('Payload para enviar:', payload)
      return payload
    },
    continuar() {
      this.$emit('continuar')
    // this.$emit('colors-customized', true)
    // this.loadCustomConfig()
    // const payload = this.saveColorsConfig()
    // console.log('Colores personalizados guardados:', payload)
    }
  }
}
</script>